import { h, render, Component } from 'preact'
import PropTypes from 'prop-types'

class TableOfContentsEnhancedApp extends Component {
  constructor (props) {
    super(props)

    this.state = {
      items: []
    }
  }

  componentDidMount () {
    const elements = document.querySelectorAll(
      `${this.props.targetSelector} h2`
    )
    if (!elements) return
    const newItems = [...elements].map((element, i) => {
      const text = element.textContent
      const elementID = `lg-${i + 1}-${text.replace(/\s+/g, '').toLowerCase()}`
      element.setAttribute('id', elementID)
      return {
        text: text,
        href: `#${elementID}`
      }
    })

    this.setState({
      items: newItems
    })
  }

  render () {
    return (
      <section className="TableOfContentsEnhanced__inner">
        <header className="TableOfContentsEnhanced__header">
          <p className="TableOfContentsEnhanced__heading">
            Innehållsförteckning
          </p>
        </header>
        {this.state.items.length > 0 && (
          <ol className="TableOfContentsEnhanced__items">
            {this.state.items.map((item, i) => (
              <li className="TableOfContentsEnhanced__item" key={i}>
                <a className="TableOfContentsEnhanced__link" href={item.href}>
                  {item.text}
                </a>
              </li>
            ))}
          </ol>
        )}
      </section>
    )
  }
}

TableOfContentsEnhancedApp.propTypes = {
  targetSelector: PropTypes.string
}

export default TableOfContentsEnhancedApp
